export default __webpack_public_path__ + "static/media/other.ae0aab0d.webp";